module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07466_logo_200x200.c1ef61f4.png";